import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e80a874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "network-info-wrap" }
const _hoisted_2 = { class: "address-info" }
const _hoisted_3 = { class: "distance" }
const _hoisted_4 = { class: "detail xag-ellipsis" }

import { withDefaults } from 'vue'
import { NetworkListRenderItem } from '@/types/malfunction-repair'
import { AUTH_WAREHOUSE, OWN_WAREHOUSE } from '@/defination/malfunction-repair'
import AppHost from '@/utils/app'
import NetworkServiceTag from './network-services-tag.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'network-info-item',
  props: {
    item: null,
    showPhone: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { item: NetworkListRenderItem, showPhone: boolean };



function getWarehouseTypeText(type: string) {
  if (type === AUTH_WAREHOUSE) {
    return '授权'
  } else if (type === OWN_WAREHOUSE) {
    return '直营'
  }
  return ''
}
function getWarehouseTagClass(type: string) {
  if (type === AUTH_WAREHOUSE) {
    return 'auth-tag'
  } else if (type === OWN_WAREHOUSE) {
    return 'own-tag'
  }
  return ''
}
function getDistanceText(distance: number) {
  if (distance > 1000) {
    return (distance / 1000).toFixed(2) + 'km'
  }
  if (distance <= 1000) {
    return distance.toFixed(2) + 'm'
  }
}
function getWarehouseTag(item: NetworkListRenderItem) {
  // if (item.type === AUTH_WAREHOUSE) {
  //   return item.auth_warehouse_tag
  // } else if (item.type === OWN_WAREHOUSE) {
  //   return item.own_warehouse_tag
  // }
  // return []
  // 现在统一都改成tags
  // return item.tags
  return item.tags || []
}
function phoneCallHandle(item: NetworkListRenderItem) {
  const phone = item.contact_phone || ''
  AppHost.postCallPhone(phone.trim(), item.name || '')
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("span", {
          class: _normalizeClass(["tag", getWarehouseTagClass(props.item.type)])
        }, _toDisplayString(getWarehouseTypeText(props.item.type)), 3),
        _createElementVNode("span", null, _toDisplayString(props.item.name), 1)
      ]),
      (__props.showPhone)
        ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            class: "info-icon",
            name: "/images/icon_dianhua.svg",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (phoneCallHandle(__props.item)), ["stop"]))
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(getDistanceText(props.item.distance)), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.item.address), 1)
    ]),
    _createVNode(NetworkServiceTag, {
      type: props.item?.type,
      tags: getWarehouseTag(props.item),
      labelName: props.item?.label_name
    }, null, 8, ["type", "tags", "labelName"])
  ]))
}
}

})